<template>
	<div class="bottom-wrapper">
		<div v-if="marker" ref="mapinfo" class="mapinfo animate__animated animate__slideInUp">
			<router-link v-if="marker.data.id && partner != 1" :to="{ path: `/point/${marker.data.id}` }" class="marker-data-wrapper">
				<div class="marker-data" :class="{ partner: partner == 1 }">
					<h3 v-html="marker.data.name"></h3>
					<p v-html="marker.data.description"></p>
				</div>
				<div v-if="partner != 1 && marker.data.done == 0" class="marker-actions">
					<div class="sparkholder yellow">{{ marker.data.points }}</div>
					<div class="action-icon"><img src="../assets/img/arrow.svg"></div>
				</div>
				<div v-else class="marker-actions">
					<div class="sparkholder done">{{ marker.data.points }}</div>
					<div class="action-icon"><img src="../assets/img/arrow.svg"></div>
				</div>
			</router-link>
			<span v-else>
				<div class="marker-data">
					<h3 v-html="marker.data.name"></h3>
					<p v-html="marker.data.description"></p>
				</div>
				<!-- <div class="marker-actions">
					<div class="sparkholder yellow">{{ marker.data.points }}</div>
					<div><img src="../assets/img/arrow.svg"></div>
				</div> -->
			</span>
		</div>
		<nav class="mobile-nav">
			<a v-for="item in navItems" :key="item.name" :href="item.link" class="bloc-icon"
				:class="{ selected: localSelected === item.id }" @click.prevent="navigate(item.link, item.id)">
				<img :src="item.icon" :alt="item.name" />
			</a>
		</nav>
	</div>
</template>

<script>
export default {
	name: 'MobileNav',
	props: {
		selected: {
			type: Number,
			default: 3
		},
		marker: {
			type: Object,
			default: null
		},
		partner: {
			type: Number,
			default: 0
		},
	},
	data() {
		return {
			localSelected: this.selected,
			navItems: [
				{ id: 1, name: 'Map', icon: require('@/assets/img/map.svg'), link: '/map' },
				{ id: 2, name: 'List', icon: require('@/assets/img/list.svg'), link: '/list' },
				{ id: 3, name: 'Profile', icon: require('@/assets/img/user.svg'), link: '/profile' },
				{ id: 4, name: 'Info', icon: require('@/assets/img/info.svg'), link: '/info' },
				{ id: 5, name: 'Partners', icon: require('@/assets/img/providers.svg'), link: '/providers' },
			]
		};
	},
	methods: {
		navigate(link, id) {
			this.localSelected = id;
			console.log(`Navigating to: ${link}`);
			this.$router.push(link);
			this.$emit('item-selected', id);
		}
	},
	mounted() {
		this.localSelected = this.selected;
	},
	watch: {
		selected(newVal) {
			this.localSelected = newVal;
		},
	}
};
</script>

<style lang="sass" scoped>
.bottom-wrapper {
	position: fixed;
	bottom: 0;
	right: 0;
	left: 0;
	z-index: 1047;
	.mapinfo {
		position: absolute;
		bottom: 80px;
		background: #F9F6F0;
		right: 0;
		left: 0;
		transition: height 1s ease 0s;
		height: auto !important;
		max-height: auto;
		z-index: 1048;
		padding: 20px 30px;
		a,span {
			color: #2A2E43;
			text-decoration: none;
			h3 {
				font-size: 1.25rem;
				margin: 0px;
				padding: 0px;
			}
			p {
				margin: 0px;
				padding: 0px;
				font-size: 0.9375rem;
				line-height: 1.0625rem;
			}
			&.marker-data-wrapper {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				justify-content: space-between;
				.marker-data {
					display: flex;
					flex-direction: column;
					max-width: 60%;
					&.partner {
						max-width: 100%;
					}
				}
				.marker-actions {
					display: flex;
					flex-direction: row;
					flex-wrap: nowrap;
					align-items: center;
					max-width: 40%;
					gap: 20px;
				}
			}
		}
	}
	.mobile-nav {
		display: flex;
		justify-content: space-around;
		background-color: #2A2E43;
		padding: 20px 20px;
		box-shadow: 0px -6px 0px #00000029;
		//gap: 46px;
		z-index: 1050;
		position: relative;
		.bloc-icon {
			text-align: center;
			img {
				width: auto;
				height: 36px;
				filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(452%) hue-rotate(1deg) brightness(117%) contrast(100%);
			}
			&.selected {
				img {
					filter: brightness(0) saturate(100%) invert(73%) sepia(53%) saturate(583%) hue-rotate(113deg) brightness(85%) contrast(91%);
				}
			}
		}
	}
}
</style>